export const data =[
  {
    "Title": "Alarming Adventures",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Aliens (1988)",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 100,
    "": "Trade",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Animax",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Marvel/Star",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Baby Huey",
    "Issue #": 22,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Baby Huey",
    "Issue #": 35,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Baby Huey",
    "Issue #": 36,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Baseball Superstars",
    "Issue #": "",
    "Condition": "VF/NM",
    "Website Notes": "Nolan Ryan",
    "Personal Notes (Not on website)": "Revolutionary",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Betie Page Queen of the Nile",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Stevens Cvr",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 50,
    "": "Comiclink",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Book and Record Set",
    "Issue #": "PR13",
    "Condition": "VG",
    "Website Notes": "w/record",
    "Personal Notes (Not on website)": "Power Records",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Book and Record Set",
    "Issue #": "PR17",
    "Condition": "G/VG",
    "Website Notes": "w/record",
    "Personal Notes (Not on website)": "Power Records",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Cerebus",
    "Issue #": 56,
    "Condition": "VF",
    "Website Notes": "Wolveroach C/S",
    "Personal Notes (Not on website)": "Aardvark-Vaneheim",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Conan Book & Record Set",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Adams Art",
    "Personal Notes (Not on website)": "Power Records",
    "Cost Basis": 15,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Dark Horse Presents",
    "Issue #": 36,
    "Condition": "NM-",
    "Website Notes": "AVP Line Drawn",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Dark Horse Presents",
    "Issue #": 36,
    "Condition": "NM-",
    "Website Notes": "AVP Photo Cvr",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Dawn",
    "Issue #": "1/2",
    "Condition": "NM",
    "Website Notes": "Wizard w/COA",
    "Personal Notes (Not on website)": "Sirius",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Demon Hunter",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas Seaboard",
    "Cost Basis": 15,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Donatello",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Donatello",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Double Talk",
    "Issue #": "NN",
    "Condition": "VG/F",
    "Website Notes": "Anti Communist",
    "Personal Notes (Not on website)": 1961,
    "Cost Basis": 75,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Eternal Warrior",
    "Issue #": 4,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Valiant",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Fatman the Human Flying Saucer",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Lightning",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Flash Gordon",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Flash Gordon",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Flash Gordon",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Flash Gordon",
    "Issue #": 8,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Flash Gordon",
    "Issue #": 9,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Flash Gordon",
    "Issue #": 10,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Flash Gordon",
    "Issue #": 11,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Flinstones at the New York World's Fair",
    "Issue #": "NN",
    "Condition": "VF",
    "Website Notes": "1st Print",
    "Personal Notes (Not on website)": "JW",
    "Cost Basis": 25,
    "": "Rich G",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Fright",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Son of Dracula",
    "Personal Notes (Not on website)": "Atlas Seaboard",
    "Cost Basis": 100,
    "": "TTReasures",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Godzilla",
    "Issue #": 0,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 15,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Grendel",
    "Issue #": 4,
    "Condition": "NM",
    "Website Notes": "Stevens C",
    "Personal Notes (Not on website)": "Comico",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Grendel",
    "Issue #": 16,
    "Condition": "NM",
    "Website Notes": "1st Mage",
    "Personal Notes (Not on website)": "Comico",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Grim Ghost",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas Seaboard",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Grim Jack",
    "Issue #": 26,
    "Condition": "NM",
    "Website Notes": "2nd color TMNT",
    "Personal Notes (Not on website)": "First",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Harbinger",
    "Issue #": 0,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Valiant",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Herbie",
    "Issue #": 5,
    "Condition": "G",
    "Website Notes": "Beatles",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Herbie",
    "Issue #": 14,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Herbie",
    "Issue #": 15,
    "Condition": "VG-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Hot Stuff Sizzlers",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "How to Draw Comics",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "1985 Byrne",
    "Personal Notes (Not on website)": "Solson",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Inhumanoids",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Marvel/Star",
    "Cost Basis": 15,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Iron Jaw",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas Seaboard",
    "Cost Basis": 15,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Jonny Quest",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "Stevens Cvr",
    "Personal Notes (Not on website)": "Comico",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Judge Dredd",
    "Issue #": 5,
    "Condition": "NM",
    "Website Notes": "Bolland",
    "Personal Notes (Not on website)": "Eagle Comics",
    "Cost Basis": 15,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Lady Death",
    "Issue #": "1/2",
    "Condition": "NM",
    "Website Notes": "Wizard W/COA",
    "Personal Notes (Not on website)": "Chaos",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Leonardo",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "1986 TMNT",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Little Lotta",
    "Issue #": 34,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Los Angeles Dodgers",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "1997 giveaway",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Macross",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "1st Robotech",
    "Personal Notes (Not on website)": "Comico",
    "Cost Basis": 100,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Madman Comics",
    "Issue #": 4,
    "Condition": "CGC 9.8",
    "Website Notes": "D Stevens",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 130,
    "": "clink",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Mandrake the Magician",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "King",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Michaelangelo",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 25,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Mighty Morphin Power Rangers",
    "Issue #": "",
    "Condition": "FN+",
    "Website Notes": "TPB",
    "Personal Notes (Not on website)": "Hamilton",
    "Cost Basis": 15,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "MiracleMan",
    "Issue #": 15,
    "Condition": "VF+",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "Eclipse",
    "Cost Basis": 75,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "MiracleMan",
    "Issue #": 15,
    "Condition": "VF",
    "Website Notes": "Classic C",
    "Personal Notes (Not on website)": "Eclipse",
    "Cost Basis": 50,
    "": "TReasures",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Noman",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Noman",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Out of This World",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Sci Fi Bondage Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 150,
    "": "BCC",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Beverly Hills 90210",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Christina Applegate",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Elvira",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Elvis Presley",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "James Dean",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Led Zeppelin",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Led Zeppelin Robert Plant",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Madonna",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Metallica",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Paula Abdul",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Paulina Porizkova",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Rickey Henderson",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Sexy Women",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Sexy Women 2",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Slam Dunk Kings 1",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Star Trek Denise Crosby",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Star Trek Marina Sertis",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Star Trek Michael Dorn",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Timothy Dalton",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Personality Comics",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "U2",
    "Personal Notes (Not on website)": "Personality Comics",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Phoenix",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas Seaboard",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Predator",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 45,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Prime Slime",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Prince",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "Bio",
    "Personal Notes (Not on website)": "Piranha",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Pro",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Ennis 2002",
    "Personal Notes (Not on website)": "Image",
    "Cost Basis": 32,
    "": "Telegraph",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Pure Images",
    "Issue #": "V3#1",
    "Condition": "NM",
    "Website Notes": "Ditko Spider-Man",
    "Personal Notes (Not on website)": "Pure Images",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Rai",
    "Issue #": 0,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Valiant",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Richie Rich",
    "Issue #": 12,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Richie Rich",
    "Issue #": 31,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Rocketeer Adv Magazine",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "Stevens C/A",
    "Personal Notes (Not on website)": "Comico",
    "Cost Basis": 10,
    "": "Jerrys friend",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Rocketeer Special Edition",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Stevens C/A",
    "Personal Notes (Not on website)": "Eclipse",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Rock Happening",
    "Issue #": 2,
    "Condition": "VG",
    "Website Notes": "Scarce",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Sad Sack and the Sarge",
    "Issue #": 25,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Saga",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Image",
    "Cost Basis": 210,
    "": "Matt",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Samurai Son of Death",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Eclipse",
    "Cost Basis": 2,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Saved By the Bell",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Scorpion",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Atlas Seaboard",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Simpsons",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Bongo",
    "Cost Basis": 125,
    "": "clink",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Solar Man of the Atom",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Valiant",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Space Ghost (1987)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Comico",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Spawn",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Image 2 avail",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Spawn",
    "Issue #": 8,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Image",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Spawn",
    "Issue #": 9,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Image 2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Spawn",
    "Issue #": 229,
    "Condition": "NM",
    "Website Notes": "Steranko Hulk Homage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ron",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Spawn",
    "Issue #": 230,
    "Condition": "NM",
    "Website Notes": "Batman 423 Homage",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Ron",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Spawn/Batman",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "Miller Auto w/COA",
    "Personal Notes (Not on website)": "Image",
    "Cost Basis": 100,
    "": "Bednarz",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Spirit",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 35,
    "": "Dahlgren",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Spirit",
    "Issue #": 2,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Star Wars: Heir to the Empire",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 1000,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Star Wars: Heir to the Empire",
    "Issue #": 1,
    "Condition": "CGC 9.6",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 500,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Star Wars: Jedi vs Sith",
    "Issue #": 1,
    "Condition": "CGC 9.8",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 500,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Star Wars: Knights of the Old Republic",
    "Issue #": 9,
    "Condition": "CGC 9.8",
    "Website Notes": "1st Darth Revan",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 1500,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Star Wars 3-D",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": 1988,
    "Personal Notes (Not on website)": "Blackthorne",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Star Wars X-Wing Rogue Squadron",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "in mailer",
    "Personal Notes (Not on website)": "Dark Horse",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Tales of the Teen Age Mutant Ninja Turtles",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Mirage 2 avail",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Tales of the Teen Age Mutant Ninja Turtles",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Tales of the Teen Age Mutant Ninja Turtles",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Teen Age Mutant Ninja Turtles",
    "Issue #": 1,
    "Condition": "VF/NM",
    "Website Notes": "4th Print",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 100,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Teen Age Mutant Ninja Turtles",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 50,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Teen Age Mutant Ninja Turtles",
    "Issue #": 2,
    "Condition": "VF/NM",
    "Website Notes": "3rd Print",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Teen Age Mutant Ninja Turtles",
    "Issue #": 3,
    "Condition": "VF/NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 50,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Teen Age Mutant Ninja Turtles",
    "Issue #": 10,
    "Condition": "NM",
    "Website Notes": "3rd Print",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Teen Age Mutant Ninja Turtles",
    "Issue #": 11,
    "Condition": "NM",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Mirage",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Thunder Agents",
    "Issue #": 1,
    "Condition": "VF+",
    "Website Notes": "Wood Art",
    "Personal Notes (Not on website)": "Tower",
    "Cost Basis": 120,
    "": "Todd",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Thunder Agents",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "Wood Art",
    "Personal Notes (Not on website)": "Tower",
    "Cost Basis": 25,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Thunder Agents",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "Wood Art",
    "Personal Notes (Not on website)": "Tower",
    "Cost Basis": 25,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Thunder Agents",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "Wood Art",
    "Personal Notes (Not on website)": "Tower",
    "Cost Basis": 25,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Thunder Agents",
    "Issue #": 3,
    "Condition": "F/VF",
    "Website Notes": "Wood Art",
    "Personal Notes (Not on website)": "Tower",
    "Cost Basis": 25,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Thunder Agents",
    "Issue #": 8,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Tower",
    "Cost Basis": 25,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Thunder Agents",
    "Issue #": 15,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Tower",
    "Cost Basis": 25,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Too Much Coffee Man",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Adhesive",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Top Secret Adventures",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "22 Brides",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "1st Painkiler Jane",
    "Personal Notes (Not on website)": "Image",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Unearthly Spectaculars",
    "Issue #": 3,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Unusual Tales",
    "Issue #": 5,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "ACG",
    "Cost Basis": 10,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Vicki",
    "Issue #": 1,
    "Condition": "VF",
    "Website Notes": "Giant",
    "Personal Notes (Not on website)": "Atlas",
    "Cost Basis": 20,
    "": "",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Walking Dead TPB",
    "Issue #": "1-32",
    "Condition": "VF/NM",
    "Website Notes": "Complete Set",
    "Personal Notes (Not on website)": "Image",
    "Cost Basis": 100,
    "": "Bednarz",
    "__1": "",
    "__2": ""
  },
  {
    "Title": "Wendy the Good Little Witch",
    "Issue #": 33,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "Harvey",
    "Cost Basis": 5,
    "": "",
    "__1": "",
    "__2": ""
  }
]
;